import { render, staticRenderFns } from "./ElementStatus.vue?vue&type=template&id=a84d6182&scoped=true"
import script from "./ElementStatus.vue?vue&type=script&lang=js"
export * from "./ElementStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84d6182",
  null
  
)

export default component.exports